import { createResponsiveSystem } from './react-responsive-system/index.js';
import { SCREEN_CLASS_MAX_WIDTHS } from '../../../core/constants/tokens-screen.js';

var _createResponsiveSyst = createResponsiveSystem({
  breakpoints: SCREEN_CLASS_MAX_WIDTHS,
  defaultScreenClass: 'xs',
  cascadeMode: 'mobile-first'
}),
    ScreenClassProvider = _createResponsiveSyst.ScreenClassProvider,
    useScreenClass = _createResponsiveSyst.useScreenClass,
    useIsScreenClassInitialized = _createResponsiveSyst.useIsScreenClassInitialized,
    responsive = _createResponsiveSyst.responsive,
    useResponsiveProps = _createResponsiveSyst.useResponsiveProps;

export { ScreenClassProvider, responsive, useIsScreenClassInitialized, useResponsiveProps, useScreenClass };